'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useCallback } from 'react'; // ✅ ОПТИМИЗАЦ`ИЯ: Импортируем useCallback
import clsx from 'clsx';

type Tab = { key: string; label: string };

type Props = {
  sortTabs: Tab[];
  categoryTabs?: Tab[];
  currentSort: string;
  currentCategory?: string;
};

export function UniversalFilterTabs({ sortTabs, categoryTabs, currentSort, currentCategory }: Props) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  // ✅ ОПТИМИЗАЦ`ИЯ: Мемоизируем функцию, чтобы она не пересоздавалась при каждом рендере.
  const handleParamChange = useCallback((key: 'sort' | 'category', value: string) => {
    const params = new URLSearchParams(searchParams);
    if (key === 'category' && value === 'all') {
      params.delete('category');
    } else {
      params.set(key, value);
    }
    // При смене фильтра всегда сбрасываем на первую страницу
    params.set('page', '1');
    // Используем `replace` вместо `push` для лучшего UX (не засоряет историю браузера)
    router.replace(`${pathname}?${params.toString()}`);
  }, [pathname, router, searchParams]);

  return (
    // ✨ "ФИШКА": Оборачиваем все в стилизованный контейнер
    <nav className="mb-8 p-4 rounded-lg bg-slate-800/50 border border-slate-700/50" aria-label="Фильтры контента">
      <div className="flex flex-col gap-4">
        {/* Сортировка */}
        {/* ✅ АДАПТИВНОСТЬ: Контейнер теперь переносит элементы на новую строку */}
        <div
            // ✅ ДОСТУПНОСТЬ: Добавляем ARIA-роли
            role="tablist"
            aria-label="Сортировка"
            // ✅ АДАПТИВНОСТЬ: Заменяем скролл на flex-wrap. Добавляем gap-y для отступов между строками.
            className="flex items-center flex-wrap gap-x-4 sm:gap-x-8 gap-y-2 border-b border-slate-700"
        >
            {sortTabs.map(tab => (
            <button
                key={tab.key}
                onClick={() => handleParamChange('sort', tab.key)}
                role="tab"
                aria-selected={currentSort === tab.key}
                // ✅ ИЗМЕНЕНИЕ: Добавляем горизонтальный отступ px-3
                className={clsx(
                  "px-3 pb-2 font-semibold transition-colors duration-200 border-b-2 -mb-px focus:outline-none focus:ring-2 focus:ring-sky-500/50 rounded-sm",
                  currentSort === tab.key
                    ? "text-sky-400 border-sky-400"
                    : "text-slate-400 border-transparent hover:text-white"
                )}
            >
                {tab.label}
            </button>
            ))}
        </div>

        {/* Фильтр по категориям */}
        {categoryTabs && (
          <div
            role="tablist"
            aria-label="Категории"
            className="flex items-center gap-2 flex-wrap pt-4" // Убираем border-t, так как он теперь не нужен
          >
            {categoryTabs.map(tab => (
              <button
                key={tab.key}
                onClick={() => handleParamChange('category', tab.key)}
                role="tab"
                aria-selected={currentCategory === tab.key}
                className={clsx(
                  "px-3 py-1 text-sm rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-800 focus:ring-sky-500",
                  currentCategory === tab.key
                    ? "bg-sky-600 text-white font-semibold shadow-md"
                    : "bg-slate-700/50 text-slate-300 hover:bg-slate-700"
                )}
              >
                {tab.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
}

